<template>
  <div class="tab-price-item">
    <div class="item-col">
      <span>If user's currency is</span>
      <el-select
        class="item-select" size="mini" v-model="price.currency" filterable remote
        placeholder="Currency" :remote-method="getCurrencies" :loading="loadingCurrencies"
        @change="selectCurrency"
      >
        <el-option
          v-for="(item) in currencies" :key="item._id" :value="item.currency"
          :label="`${item.symbol} ${item.currency === item.symbol ? '' : `- ${item.currency}`}`"
        ></el-option>
      </el-select>
    </div>
    <div class="item-col">
      <span>then display price</span>
      <el-input class="item-input" size="mini" step="0.01" type="number" v-model.number="price.price" placeholder="Price" @change="handleChange">
        <template #prepend>{{ price.symbol }}</template>
      </el-input>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'TabPrice',
  props: {
    actionIndex: Number,
    actionItem: Object
  },
  emits: ['handleUpdate'],
  components: {
  },
  data () {
    return {
      price: this.actionItem,
      currencies: [],
      loadingCurrencies: false
    }
  },
  created: function () {
    this.getCurrencies('')
  },
  mounted () {
  },
  computed: {
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        this.price = val
      },
      deep: true
    }
  },
  methods: {
    getCurrencies: function (query) {
      this.loadingCurrencies = true
      const url = `/api/v1/atk_player/currencies?page_num=1&page_size=40&is_deleted=false&name=${query}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.currencies = res.data.list
        } else {
          console.error('getCurrencies', res.msg)
        }
        that.loadingCurrencies = false
      }).catch(function (err) {
        that.loadingCurrencies = false
        console.error('getCurrencies', err)
      })
    },
    handleChange () {
      this.$emit('handleUpdate', this.actionIndex, this.price)
    },
    selectCurrency: function (val) {
      const index = _.findIndex(this.currencies, { currency: val })
      if (index > -1) {
        this.price.symbol = this.currencies[index].symbol
        this.$emit('handleUpdate', this.actionIndex, this.price)
      }
    }
  }
}
</script>
<style scoped lang="scss">
.tab-price-item {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding: 0 20px;
  .item-col {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .item-select {
      width: 128px;
      margin-left: 10px;
    }
    .item-input {
      width: 150px;
      margin-left: 10px;
    }
  }
}
</style>
